module.exports = __webpack_public_path__ + "static/BSVid2-52dd3a294aae5c796c3de0ae02d5f6b7.mp4";